import { FC, PropsWithChildren } from 'react';
import * as Sentry from '@sentry/react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorPage } from './ErrorPage';

export const ErrorBoundaryWrapper: FC<PropsWithChildren> = ({ children }) => {
  const handleError = (error: Error, info: { componentStack: string }) => {
    // Capture the error in Sentry with component info
    Sentry.withScope((scope) => {
      scope.setLevel('error');
      scope.setContext('componentInfo', {
        componentStack: info.componentStack,
      });

      Sentry.captureException(error);

      Sentry.showReportDialog({
        title: 'Something went wrong',
        subtitle:
          "Our team has been notified. If you'd like to help, tell us what happened below.",
        subtitle2: '',
        labelName: 'Name',
        labelEmail: 'Email',
        labelComments: 'What happened?',
        labelClose: 'Close',
        labelSubmit: 'Submit Feedback',
        errorGeneric:
          'An unknown error occurred while submitting your report. Please try again.',
        errorFormEntry:
          'Some fields were invalid. Please correct the errors and try again.',
        successMessage: 'Your feedback has been sent. Thank you!',
      });
    });
  };

  return (
    <ErrorBoundary
      FallbackComponent={ErrorPage}
      onError={handleError}
      onReset={() => {
        window.location.href = '/';
      }}
    >
      {children}
    </ErrorBoundary>
  );
};
